import * as actionTypes from './actionTypes';
import { getUserModules, updateCrmModule as updateCrmModuleReq, deleteModule } from '../../axios/requests/moduleReq'
// import axios from '../../axios/Backend';

export const setRouteParams = (params) => {
  return {
    type: actionTypes.SET_ROUTE_PARAMS,
    payload: {
      params
    }
  };
};

export const updateQueryParams = (queryParams) => ({
  type: actionTypes.UPDATE_QUERY_PARAMS,//"UPDATE_QUERY_PARAMS"
  payload: {
    queryParams
  }
});

export const updateDashboardSection = (dashboardSection) => ({
  type: actionTypes.UPDATE_DASHBOARD_SECTION,//UPDATE_DASHBOARD_SECTION
  payload: {
    dashboardSection
  },
});

export const setCrmModule = (crmModule, selectionMode) => ({
  type: actionTypes.SET_CRM_MODULE,//SET_CRM_MODULE
  payload: {
    crmModule,
    selectionMode
  },
});

export const refreshCrmModule = (moduleName) => {
  return async (dispatch) => {
    const moduleArr = await getUserModules(moduleName)
    const module = moduleArr?.[0]
    dispatch(setCrmModule(module, 'refresh'))

  }
}

const startLoading = () => {
  return {
    type: actionTypes.START_CRM_LOADING
  }
}

const finishLoading = ({ errorMsg, successMsg }) => {
  return {
    type: actionTypes.FINISH_CRM_LOADING,
    payload: {
      errorMsg,
      successMsg
    }
  }
}

export const updateCrmModule = (moduleObj, successMsg = 'The operation was successful') => {
  return async (dispatch) => {
    try {
      dispatch(startLoading())
      const resData = await updateCrmModuleReq(moduleObj)
      dispatch(setCrmModule(resData, 'refresh'))
      dispatch(finishLoading({ successMsg }))
    }
    catch (e) {
      dispatch(finishLoading({ errorMsg: e.message }))
      // dispatch(finishLoading())
    }
  }
}

export const onCloseCrmAlertModalHandler = () => {
  return {
    type: actionTypes.CLEAR_CRM_ALERT
  }
}

const initModules = (moduleList) => {
  return {
    type: actionTypes.INIT_CRM_MODULE_LIST,
    payload: {
      moduleList
    }
  }
}

export const initCrmModule = () => {
  return async (dispatch) => {
    const moduleList = await getUserModules()
    dispatch(initModules(moduleList))
  }
}

export const changeCrmModuleOrder = (active, over) => {
  return {
    type: actionTypes.CHANGE_CRM_MODULE_ORDER,
    payload: {
      active, over
    }
  }
}

export const clearPendingModuleOrder = () => {
  return {
    type: actionTypes.CLEAR_PENDING_MODULE_ORDER
  }
}

export const addOrUpdateNavPath = (segment) => ({
  type: actionTypes.ADD_OR_UPDATE_NAV_PATH,
  payload: segment            // { module, recordId, label, href }
});

export const deleteModuleFromList = (moduleId) => {
  return {
    type: actionTypes.DELETE_MODULE,
    payload: {
      moduleId
    }
  }
}

export const deleteModuleById = (moduleId) => {
  return async (dispatch) => {
    const isDeleted = await deleteModule(moduleId)
    if (isDeleted) dispatch(deleteModuleFromList(moduleId))
  }
}